import React, { useState, useEffect, useContext, createContext } from "react";

import { ajaxInstance } from "../utils/axios";
import _ from "lodash";

function deleteAllLocalStorage () {
    console.log("HERE WE DELETE ALL LOCALSTORAGE")
}

function deleteAllCookies () {
  return new Promise((resolve, reject) => {
    console.log("HERE WE CLEAN COOKIES")
    resolve(true)
  })
}

const DEFAULT_USER = {
  id: null,
  logged: null,
  is_admin: false,
};

const authContext = createContext();

// ... available to any child component that calls useAuth().
export function ProvideAuth({ children }) {
    const auth = useProvideAuth();
    return <authContext.Provider value={auth}>{children}</authContext.Provider>;
}

// Hook for child components to get the auth object ...
// ... and re-render when it changes.
export const useAuth = () => {
    return useContext(authContext);
};

function useProvideAuth() {
    const [csrf, setCsrf] = useState("");
    let csrfUrl = "/api/csrf";
    let registerUrl  = "/api/register";
    let signinrUrl = '/api/login';
    let sessionUrl = '/api/session';
    let signoutUrl = '/api/logout';
    let verifyEmailUrl = '/api/verify';
    let recoverUrl = '/api/recover';
    let restartUrl = '/api/restart/account';
    const [checkSessionIntervalId, setCheckSessionIntervalId] = useState(null);
    const [user, setUser] = useState(DEFAULT_USER);

    const updateCsrfToken = (csrfToken) => {
        setCsrf(csrfToken);
        ajaxInstance.defaults.headers.common["X-CSRF-TOKEN"] = csrfToken;
    };

    const cleanAll = () => {
        deleteAllCookies()
        .then(() => deleteAllLocalStorage())
    }

    const isValidSession = () => {
      return new Promise((resolve, reject) => {
        ajaxInstance
          .get(sessionUrl)
          .then((response) => {
            const data = response.data;
            if (response.status === 200) {
              resolve(data.data);
            } else {
              reject();
            }
          })
          .catch((error) => {
            reject();
          });
      });
    };
  

    const getCsrfToken = () => {
        return new Promise((resolve, reject) => {
          ajaxInstance
            .get(csrfUrl)
            .then((response) => {
              const data = response.data;
              if (response.status === 200) {
                resolve(data.data);
              } else {
                reject();
              }
            })
            .catch(() => {
              console.log("error get csrf");
              reject();
            });
        });
      };

    const signup = (fullname, email, password, terms, iamafiliate, ib_number) => {
      return new Promise((resolve, reject) => {
        ajaxInstance.post(
          registerUrl,{
            "name": fullname,
            "email": email,
            "password": password,
            "terms": terms,
            "iamafiliate": iamafiliate,
            "ib_number": ib_number
          }
        ).then((response) => {
          if (response.status === 200) {
            resolve(true);
          }
        }).catch((error) => {
          const data = error.response.data
          const errors = data.errors
          console.log("error when registering user", errors)
          reject(errors);
        })
      })
    }
    const signout = () => {
      return new Promise((resolve, reject) => {
        ajaxInstance.post(
          signoutUrl
        ).then((response) => {
          if (response.status === 200) {
            getCsrfToken()
            .then((csrfToken) => {
              updateCsrfToken(csrfToken);
            })
           resolve(true)
          }
        }).catch((error) => {
          const data = error.response.data
          const errors = data.errors
          console.log("error when login outuser", errors)
          reject(errors);
        })
      })
    }
    const signin = (email, password) => {
      return new Promise((resolve, reject) => {
        ajaxInstance.post(
          signinrUrl,{
            "email": email,
            "password": password,
          }
        ).then((response) => {
          if (response.status === 200) {
            getCsrfToken()
            .then((csrfToken) => {
              updateCsrfToken(csrfToken);
            })
            isValidSession().then((sessionData) => {
              const userData = sessionData;
              setUser({
                ...userData,
                ib_number: userData.is_admin || user.is_staff ? 8019359976: userData.ib_number,
                logged: true,
              });
              resolve("success");
            })
            .catch((error) => {
              console.log(error);
              reject();
            });
          }
        }).catch((error) => {
          const data = error.response.data
          const errors = data.errors
          console.log("error when login in  user", errors)
          reject(errors);
        })
      })
    }
    const verifyEmail = (code, hashed_id) => {
      return new Promise((resolve,reject) => {
        ajaxInstance
          .post(verifyEmailUrl, {code: code, id: hashed_id})
          .then((response) => {
              if(response.status === 200){
                resolve(true)
              }
          }).catch((error) => {
            const data = error.response.data
            const errors = data.errors
            console.log("error on email verification", errors)
            reject(errors);
          })
      })
    }

    const recoverAccountRequest = (email) => {
      return new Promise((resolve,reject) => {
        ajaxInstance
          .post(recoverUrl, {email: email})
          .then((response) => {
              if(response.status === 200){
                  resolve(true)
              }
          }).catch((error) => {
            const data = error.response.data
            const errors = data.errors
            console.log("errors on account recovery request", errors)
            reject(errors);
          })
      })
    }

    const restartPassword = (new_password,code, hashed_id) => {
      return new Promise((resolve,reject) => {
        ajaxInstance
          .post(restartUrl, {newPassword: new_password, code: code, id: hashed_id})
          .then((response) => {
              if(response.status === 200){
                resolve(true)
              }
          }).catch((error) => {
            const data = error.response.data
            const errors = data.errors
            console.log("error on account password reset", errors)
            reject(errors);
          })
      })
    }

    useEffect(() => {
    getCsrfToken()
        .then((csrfToken) => {
            updateCsrfToken(csrfToken);
            isValidSession().then((sessionData) => {
              let newSessionData = {
                ...sessionData
              }
              if(newSessionData.is_admin || newSessionData.is_staff){
                newSessionData["ib_number"] = 8019359976
              }
              setUser({
                ...newSessionData,
                logged: true,
              });
            }).catch(() => {
                console.error("fail auth hook useEffect");
                cleanAll();
                setUser({
                  id: null,
                  logged: false,
                  is_admin: false,
                })
            });
        })
        .catch(() => {
            console.error("fail auth hook useEffect");
            cleanAll();
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
      if (user.logged) {
        // Se obtienen variables de session y se actualizan
        if (!_.isNil(checkSessionIntervalId))
          clearInterval(checkSessionIntervalId);
        const sessionIntervalId = setInterval(() => {
          isValidSession()
            .then((sessionData) => {
              let newSessionData = {
                ...sessionData
              }
              if(newSessionData.is_admin || newSessionData.is_staff){
                newSessionData["ib_number"] = 8019359976
              }
              setUser({
                ...newSessionData,
                logged: true,
              });
            })
            .catch(() => {
              console.log('Error on getting session');
              cleanAll();
            });
            // the session is only for 1 hour
        }, 3600000);
        setCheckSessionIntervalId(sessionIntervalId);
      }
    }, [user.logged]);
  

    return {
        user,
        csrf,
        signup,
        signin,
        signout,
        verifyEmail,
        recoverAccountRequest,
        restartPassword,
    }
}

